// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface GetServiceStatisticsOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface GetKnowledgeSourceStatusOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateKnowledgeSourceOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface ListKnowledgeSourcesOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface GetKnowledgeSourceOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface DeleteKnowledgeSourceOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateOrUpdateKnowledgeSourceOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateKnowledgeBaseOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface ListKnowledgeBasesOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface GetKnowledgeBaseOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface DeleteKnowledgeBaseOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateOrUpdateKnowledgeBaseOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateAliasOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface ListAliasesOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface GetAliasOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface DeleteAliasOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateOrUpdateAliasOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface AnalyzeTextOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface GetIndexStatisticsOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateIndexOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface ListIndexesWithSelectedPropertiesOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Selects which top-level properties to retrieve. Specified as a comma-separated list of JSON property names, or '*' for all properties. The default is all properties. */
  select?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface ListIndexesOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface GetIndexOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface DeleteIndexOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateOrUpdateIndexOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** Allows new analyzers, tokenizers, token filters, or char filters to be added to an index by taking the index offline for at least a few seconds. This temporarily causes indexing and query requests to fail. Performance and write availability of the index can be impaired for several minutes after the index is updated, or longer for very large indexes. */
  allowIndexDowntime?: boolean;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateSynonymMapOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface GetSynonymMapsOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Selects which top-level properties to retrieve. Specified as a comma-separated list of JSON property names, or '*' for all properties. The default is all properties. */
  select?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface GetSynonymMapOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface DeleteSynonymMapOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}

/** Optional parameters. */
export interface CreateOrUpdateSynonymMapOptionalParams extends OperationOptions {
  /** The Accept header. */
  accept?: "application/json;odata.metadata=minimal";
  /** Defines the If-Match condition. The operation will be performed only if the ETag on the server matches this value. */
  ifMatch?: string;
  /** Defines the If-None-Match condition. The operation will be performed only if the ETag on the server does not match this value. */
  ifNoneMatch?: string;
  /** An opaque, globally-unique, client-generated string identifier for the request. */
  clientRequestId?: string;
}
